import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';

import { iamSetRefreshTokenAttributes } from '@crossnokaye/typescript-sdk/funcs/iamSetRefreshTokenAttributes';
import {
  SetRefreshTokenAttributesRequest,
  SetRefreshTokenAttributesResponse,
} from '@crossnokaye/typescript-sdk/models/operations';

import { atlasClient } from '@/clients/atlas';

export type SetRefreshTokenAttributesOptions = Omit<
  UseMutationOptions<SetRefreshTokenAttributesResponse, Error, SetRefreshTokenAttributesRequest>,
  'mutationFn'
>;

export type SetRefreshTokenAttributesResult = UseMutationResult<
  SetRefreshTokenAttributesResponse,
  Error,
  SetRefreshTokenAttributesRequest
>;

export function useSetRefreshTokenAttributes(
  options?: SetRefreshTokenAttributesOptions
): SetRefreshTokenAttributesResult {
  return useMutation<SetRefreshTokenAttributesResponse, Error, SetRefreshTokenAttributesRequest>({
    mutationFn: async (request: SetRefreshTokenAttributesRequest) =>
      atlasClient<SetRefreshTokenAttributesRequest, SetRefreshTokenAttributesResponse>({
        atlasFunc: iamSetRefreshTokenAttributes,
        request,
      }),
    ...options,
  });
}
